import { showAlertModal } from "../../jsx/pages/trybz_dashboard/_components/customModals/AlertModal";
import {
  showBusyModal,
  hideBusyModal,
} from "../../jsx/pages/trybz_dashboard/_components/customModals/BusyModal";

interface ExecWebRequestInput<T> {
  message?: string;
  execute: () => Promise<T>;
  onSuccess?: (result: T) => void;
  onError?: (error: any) => void;
  onComplete?: () => void;
}

export default async function execWebRequest<T>(input: ExecWebRequestInput<T>) {
  try {
    showBusyModal(input.message);
    const result = await input.execute();
    if (input.onSuccess) input.onSuccess(result);
  } catch (error) {
    if (
      (error as any).response.data.error === "0.streetName should not be empty"
    ) {
      return showAlertModal({
        title: "Something went wrong...",
        message: "Location entered does not include a street name. Try again.",
      });
    } else if (
      (error as any).response.data.error ===
      "Cannot create these units because some of them would have the same name."
    ) {
      return showAlertModal({
        title: "Something went wrong...",
        message:
          "Cannot create these units because some of them would have the same name. Tip: Is Extension [Ext] needed in the naming convention?",
      });
    } else if ((error as any).response.data.error === "Unit type should not be null since estate additional member type is Vary.") {
      return showAlertModal({
        title: "Something went wrong...",
        message: "This unit does not have a unit type specified. Please proceed to update the unit type in the edit unit details page."
      })
    }
    else if (
      (error as any).response.data.error?.includes(
        "Unable to find a Biller Entity"
      )
    ) {
      return showAlertModal({
        title: "Something went wrong...",
        message:
          "This account is not a biller entity yet and thus cannot perform this action. Register this entity as a Biller Entity before proceeding.",
      });
    } else if ((error as any).response.data.error?.includes("Cannot GET /v1/social/communities")) {
      return showAlertModal({
        title: "User Not Found",
        message: "No User Found With The Provided Social Id"
      })
    }

    showAlertModal({
      message: (error as any).response.data.error,
      title: "Something went wrong...",
    }).then(() => {
      if (input.onError) input.onError(error);
    });
  } finally {
    hideBusyModal();
    if (input.onComplete) input.onComplete();
  }
}
